import Modal from 'react-modal';
import {useTranslation} from "react-i18next";
import './modal.css'

const NewCategoryModal = ({ visible, onClose, onChangeName, onSave, isModifier }) => {
    const { t } = useTranslation()

    return (
        <Modal
            isOpen={visible}
            onRequestClose={onClose}
            closeTimeoutMS={200}
            shouldCloseOnOverlayClick={true}
            ariaHideApp={false}
            className="mt-20 mb-6 bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:w-full sm:max-w-2xl sm:mx-auto"
            style={{
                overlay: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(107, 114, 128, 0.75)",
                },
            }}
        >
            <div className="">
                <div className="px-11 pt-12 pb-5">
                    <div className="font-bold text-xl">{isModifier? t("Add Modifier Category") : t("Add Category")}</div>

                    <div className="bg-white sm:py-6">
                        <div className="col-span-2">
                            <input
                                onChange={onChangeName}
                                placeholder={t("Name")}
                                className="input border-none focus:ring-gray-200 px-2 focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                id="name"
                                type="text"
                                autoFocus="autofocus"
                            />
                        </div>
                    </div>

                    <div className="pt-8 text-right">
                        <button
                            onClick={onClose}
                            className="inline-flex justify-center mr-2 py-1.5 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-300 hover:bg-gray-400 activ:bg-gray-500 focus:outline-none"
                        >
                            {t("Cancel")}
                        </button>
                        <button
                            onClick={onSave}
                            className="inline-flex justify-center py-1.5 px-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                        >
                            {t("Save")}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default NewCategoryModal;
